export const presets = {
  'Event Horizon': {
    osc1: { type: 'sawtooth', detune: 0 },
    osc2: { type: 'sawtooth', detune: 7 },
    oscMix: 0.5,
    fmEnabled: false,
    fmAmount: 0,
    filter: { cutoff: 2000, resonance: 2, type: 'lowpass' },
    ampEnv: { attack: 0.4, decay: 0.8, sustain: 0.7, release: 1.5 },
    effects: {
      reverb: { wet: 0.6, decay: 5 },
      delay: { wet: 0.3, time: 0.375, feedback: 0.45 },
      chorus: { wet: 0.4, frequency: 0.8, depth: 0.8 },
      distortion: { wet: 0, amount: 0 },
      phaser: { wet: 0, frequency: 0.5, octaves: 3 },
    },
    arp: { enabled: false, pattern: 'up', rate: '8n', octaves: 2 },
    lfo: { rate: 0.3, depth: 0.2, destination: 'filter' },
  },

  'Pulsar': {
    osc1: { type: 'square', detune: 0 },
    osc2: { type: 'sawtooth', detune: 0 },
    oscMix: 0.3,
    fmEnabled: false,
    fmAmount: 0,
    filter: { cutoff: 3000, resonance: 4, type: 'lowpass' },
    ampEnv: { attack: 0.005, decay: 0.15, sustain: 0.2, release: 0.1 },
    effects: {
      reverb: { wet: 0.2, decay: 1.5 },
      delay: { wet: 0.4, time: 0.125, feedback: 0.5 },
      chorus: { wet: 0, frequency: 1.5, depth: 0.7 },
      distortion: { wet: 0.1, amount: 0.2 },
      phaser: { wet: 0, frequency: 0.5, octaves: 3 },
    },
    arp: { enabled: true, pattern: 'up', rate: '16n', octaves: 2 },
    lfo: { rate: 4, depth: 0.3, destination: 'filter' },
  },

  'Nebula Drift': {
    osc1: { type: 'sine', detune: 0 },
    osc2: { type: 'triangle', detune: 5 },
    oscMix: 0.6,
    fmEnabled: false,
    fmAmount: 0,
    filter: { cutoff: 1500, resonance: 1, type: 'lowpass' },
    ampEnv: { attack: 1.0, decay: 1.5, sustain: 0.8, release: 3.0 },
    effects: {
      reverb: { wet: 0.7, decay: 8 },
      delay: { wet: 0.3, time: 0.5, feedback: 0.55 },
      chorus: { wet: 0.5, frequency: 0.3, depth: 0.9 },
      distortion: { wet: 0, amount: 0 },
      phaser: { wet: 0.3, frequency: 0.2, octaves: 2 },
    },
    arp: { enabled: false, pattern: 'up', rate: '4n', octaves: 2 },
    lfo: { rate: 0.15, depth: 0.4, destination: 'filter' },
  },

  'Supernova': {
    osc1: { type: 'sawtooth', detune: 0 },
    osc2: { type: 'square', detune: -5 },
    oscMix: 0.4,
    fmEnabled: false,
    fmAmount: 0,
    filter: { cutoff: 6000, resonance: 3, type: 'lowpass' },
    ampEnv: { attack: 0.005, decay: 0.2, sustain: 0.5, release: 0.3 },
    effects: {
      reverb: { wet: 0.2, decay: 2 },
      delay: { wet: 0.15, time: 0.2, feedback: 0.25 },
      chorus: { wet: 0, frequency: 1.5, depth: 0.7 },
      distortion: { wet: 0.3, amount: 0.5 },
      phaser: { wet: 0, frequency: 0.5, octaves: 3 },
    },
    arp: { enabled: false, pattern: 'up', rate: '8n', octaves: 2 },
    lfo: { rate: 6, depth: 0.1, destination: 'pitch' },
  },

  'Dark Matter': {
    osc1: { type: 'sawtooth', detune: 0 },
    osc2: { type: 'square', detune: 12 },
    oscMix: 0.5,
    fmEnabled: false,
    fmAmount: 0,
    filter: { cutoff: 800, resonance: 5, type: 'lowpass' },
    ampEnv: { attack: 0.01, decay: 0.4, sustain: 0.8, release: 0.3 },
    effects: {
      reverb: { wet: 0.15, decay: 1.5 },
      delay: { wet: 0.1, time: 0.15, feedback: 0.2 },
      chorus: { wet: 0.2, frequency: 1, depth: 0.5 },
      distortion: { wet: 0.15, amount: 0.4 },
      phaser: { wet: 0, frequency: 0.5, octaves: 3 },
    },
    arp: { enabled: false, pattern: 'up', rate: '8n', octaves: 1 },
    lfo: { rate: 0.5, depth: 0.15, destination: 'filter' },
  },

  'Solar Wind': {
    osc1: { type: 'triangle', detune: 0 },
    osc2: { type: 'sine', detune: 3 },
    oscMix: 0.5,
    fmEnabled: false,
    fmAmount: 0,
    filter: { cutoff: 4000, resonance: 1.5, type: 'lowpass' },
    ampEnv: { attack: 0.1, decay: 0.5, sustain: 0.6, release: 0.8 },
    effects: {
      reverb: { wet: 0.4, decay: 4 },
      delay: { wet: 0.25, time: 0.3, feedback: 0.4 },
      chorus: { wet: 0.3, frequency: 1.2, depth: 0.6 },
      distortion: { wet: 0, amount: 0 },
      phaser: { wet: 0.2, frequency: 0.3, octaves: 2 },
    },
    arp: { enabled: false, pattern: 'up-down', rate: '8n', octaves: 2 },
    lfo: { rate: 1, depth: 0.1, destination: 'amplitude' },
  },

  'Quasar': {
    osc1: { type: 'sine', detune: 0 },
    osc2: { type: 'sine', detune: 0 },
    oscMix: 0,
    fmEnabled: true,
    fmAmount: 300,
    filter: { cutoff: 8000, resonance: 1, type: 'lowpass' },
    ampEnv: { attack: 0.001, decay: 1.0, sustain: 0.1, release: 1.5 },
    effects: {
      reverb: { wet: 0.5, decay: 4 },
      delay: { wet: 0.3, time: 0.2, feedback: 0.35 },
      chorus: { wet: 0, frequency: 1.5, depth: 0.7 },
      distortion: { wet: 0, amount: 0 },
      phaser: { wet: 0, frequency: 0.5, octaves: 3 },
    },
    arp: { enabled: false, pattern: 'up', rate: '8n', octaves: 2 },
    lfo: { rate: 3, depth: 0.15, destination: 'filter' },
  },

  'Cosmic Dust': {
    osc1: { type: 'sawtooth', detune: 0 },
    osc2: { type: 'sawtooth', detune: -7 },
    oscMix: 0.5,
    fmEnabled: false,
    fmAmount: 0,
    filter: { cutoff: 1200, resonance: 6, type: 'bandpass' },
    ampEnv: { attack: 0.5, decay: 2.0, sustain: 0.3, release: 4.0 },
    effects: {
      reverb: { wet: 0.8, decay: 10 },
      delay: { wet: 0.4, time: 0.6, feedback: 0.6 },
      chorus: { wet: 0.6, frequency: 0.4, depth: 1 },
      distortion: { wet: 0, amount: 0 },
      phaser: { wet: 0.4, frequency: 0.15, octaves: 4 },
    },
    arp: { enabled: false, pattern: 'random', rate: '4n', octaves: 3 },
    lfo: { rate: 0.1, depth: 0.5, destination: 'filter' },
  },

  'Gravity Well': {
    osc1: { type: 'sawtooth', detune: 0 },
    osc2: { type: 'triangle', detune: 24 },
    oscMix: 0.35,
    fmEnabled: false,
    fmAmount: 0,
    filter: { cutoff: 2500, resonance: 3, type: 'lowpass' },
    ampEnv: { attack: 0.02, decay: 0.3, sustain: 0.4, release: 0.5 },
    effects: {
      reverb: { wet: 0.3, decay: 3 },
      delay: { wet: 0.35, time: 0.166, feedback: 0.45 },
      chorus: { wet: 0.2, frequency: 2, depth: 0.5 },
      distortion: { wet: 0.05, amount: 0.15 },
      phaser: { wet: 0, frequency: 0.5, octaves: 3 },
    },
    arp: { enabled: true, pattern: 'up-down', rate: '16n', octaves: 3 },
    lfo: { rate: 2, depth: 0.25, destination: 'filter' },
  },

  'Wormhole': {
    osc1: { type: 'square', detune: 0 },
    osc2: { type: 'sawtooth', detune: 1 },
    oscMix: 0.5,
    fmEnabled: true,
    fmAmount: 150,
    filter: { cutoff: 3500, resonance: 4, type: 'lowpass' },
    ampEnv: { attack: 0.02, decay: 0.5, sustain: 0.5, release: 1.0 },
    effects: {
      reverb: { wet: 0.5, decay: 6 },
      delay: { wet: 0.5, time: 0.333, feedback: 0.55 },
      chorus: { wet: 0.3, frequency: 0.6, depth: 0.8 },
      distortion: { wet: 0.1, amount: 0.25 },
      phaser: { wet: 0.5, frequency: 0.8, octaves: 3 },
    },
    arp: { enabled: false, pattern: 'random', rate: '8n', octaves: 2 },
    lfo: { rate: 1.5, depth: 0.35, destination: 'filter' },
  },
};
